import * as React from 'react'
import PropTypes from 'prop-types'
import { NumberField as BaseNumberField } from '@base-ui/react/number-field'
import IconButton from '@mui/material/IconButton'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputAdornment from '@mui/material/InputAdornment'
import InputLabel from '@mui/material/InputLabel'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

/**
 * This component is a placeholder for FormControl to correctly set the shrink label state on SSR.
 */
function SSRInitialFilled() {
  return null
}
SSRInitialFilled.muiName = 'Input'

function NumberField({ id: idProp, label, error, size = 'medium', ...other }) {
  let id = React.useId()
  if (idProp) {
    id = idProp
  }
  return (
    <BaseNumberField.Root
      {...other}
      render={(props, state) => (
        // eslint-disable-next-line react/prop-types
        <FormControl size={size} ref={props.ref} disabled={state.disabled} required={state.required} error={error} variant='outlined'>
          {/* eslint-disable-next-line react/prop-types */}
          {props.children}
        </FormControl>
      )}
    >
      <SSRInitialFilled {...other} />
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <BaseNumberField.Input
        id={id}
        render={({ ref, onBlur, onChange, onKeyUp, onKeyDown, onFocus, ...rest }, state) => (
          <OutlinedInput
            label={label}
            inputRef={ref}
            value={state.inputValue}
            onBlur={onBlur}
            onChange={onChange}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            slotProps={{
              input: rest
            }}
            endAdornment={
              <InputAdornment
                position='end'
                sx={{
                  flexDirection: 'column',
                  maxHeight: 'unset',
                  alignSelf: 'stretch',
                  borderLeft: '1px solid',
                  borderColor: 'divider',
                  ml: 0,
                  '& button': {
                    py: 0.5,
                    px: 0.5,
                    flex: 1,
                    borderRadius: 0.5
                  }
                }}
              >
                <BaseNumberField.Increment render={<IconButton size={size} aria-label='Increase' />}>
                  <KeyboardArrowUpIcon fontSize={size} sx={{ transform: 'translateY(2px)' }} />
                </BaseNumberField.Increment>

                <BaseNumberField.Decrement render={<IconButton size={size} aria-label='Decrease' />}>
                  <KeyboardArrowDownIcon fontSize={size} sx={{ transform: 'translateY(-2px)' }} />
                </BaseNumberField.Decrement>
              </InputAdornment>
            }
            sx={{
              pr: 0,
              width: { xs: '65px', sm: '80px' }
            }}
          />
        )}
      />
    </BaseNumberField.Root>
  )
}

NumberField.propTypes = {
  error: PropTypes.bool,
  /**
   * The id of the input element.
   */
  id: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'small'])
}

export default NumberField
